module.exports = __webpack_public_path__ + "static/media/noChat.628c6f2e.png";